import React, { useEffect, useState } from "react";
import { Chart as ChartJS, registerables } from "chart.js";
import { Bar } from "react-chartjs-2";
import { getArticleDailyStats } from "../../../api/statistics/article/ArticleStatisticsAPI";
import { useSnackbar } from "notistack";
import { singleField } from "../../../util/ArrayUtil";
import { useTranslation } from "react-i18next";
import { errorNoti } from "../../../util/SnackbarMessage";

ChartJS.register(...registerables);

type ChartProps = {
  day: number;
};

function DailyChartWrapper(props: ChartProps) {
  const [dailyData, setDailyData] = useState([]);
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation(["common", "error"]);
  useEffect(() => {
    getArticleDailyStats(props.day)
      .then((res) => setDailyData(res))
      .catch((err) => {
        var noti = errorNoti(err);
        enqueueSnackbar(t("error:" + noti.message), noti.option);
      });
  }, []);

  return (
    <Bar
      data={{
        labels: singleField(dailyData, "day"),
        datasets: [
          {
            label: "Tổng số bài báo thu thập được",
            backgroundColor: "#48B0F7",
            data: singleField(dailyData, "count"),
          },
        ],
      }}
      options={{
        plugins: {
          legend: { display: false },
          title: {
            display: true,
            text:
              "Số bài báo thu thập được/ngày (" + props.day + " ngày gần nhất)",
          },
        },
      }}
    />
  );
}

export default DailyChartWrapper;
